import { defineMessages } from 'react-intl';

import { roles, categories as categoryKeys } from 'shared/constants/crew';

export default defineMessages({
  [roles.DIRECTOR]: {
    id: 'shared.crew.director',
    defaultMessage: 'Director',
  },
  [roles.CO_DIRECTOR]: {
    id: 'shared.crew.co-director',
    defaultMessage: 'Co-Director',
  },
  [roles.PRODUCER]: {
    id: 'shared.crew.producer',
    defaultMessage: 'Producer',
  },
  [roles.EXECUTIVE_PRODUCER]: {
    id: 'shared.crew.executive-producer',
    defaultMessage: 'Executive Producer',
  },
  [roles.CO_PRODUCER]: {
    id: 'shared.crew.co-producer',
    defaultMessage: 'Co-Producer',
  },
  [roles.ASSOCIATE_PRODUCER]: {
    id: 'shared.crew.associate-producer',
    defaultMessage: 'Associate Producer',
  },
  [roles.COLLABORATING_DIRECTOR]: {
    id: 'shared.crew.collaborating-director',
    defaultMessage: 'Collaborating Director',
  },
  [roles.PRODUCTION_MANAGER]: {
    id: 'shared.crew.production-manager',
    defaultMessage: 'Production Manager',
  },
  [roles.PRODUCTION_COORDINATOR]: {
    id: 'shared.crew.production-coordinator',
    defaultMessage: 'Production Coordinator',
  },
  [roles.PRODUCTION_ASSISTANT]: {
    id: 'shared.crew.production-assistant',
    defaultMessage: 'Production Assistant',
  },
  [roles.ASSISTANT_DIRECTOR]: {
    id: 'shared.crew.assistant-director',
    defaultMessage: 'Assistant Director',
  },
  [roles['2ND_ASSISTANT_DIRECTOR']]: {
    id: 'shared.crew.2nd-assistant-director',
    defaultMessage: '2nd Assistant Director',
  },
  [roles.SCRIPT_SUPERVISOR]: {
    id: 'shared.crew.script-supervisor',
    defaultMessage: 'Script Supervisor',
  },
  [roles.LOCATION_MANAGER]: {
    id: 'shared.crew.location-manager',
    defaultMessage: 'Location Manager',
  },
  [roles.WRITER]: {
    id: 'shared.crew.writer',
    defaultMessage: 'Writer',
  },
  [roles.CO_WRITER]: {
    id: 'shared.crew.co-writer',
    defaultMessage: 'Co-Writer',
  },
  [roles.STORY]: {
    id: 'shared.crew.story',
    defaultMessage: 'Story',
  },
  [roles.ADAPTATION]: {
    id: 'shared.crew.adaptation',
    defaultMessage: 'Adaptation',
  },
  [roles.AUTHOR_OF_ADAPTED_MATERIAL]: {
    id: 'shared.crew.author-of-adapted-material',
    defaultMessage: 'Author of Adapted Material',
  },
  [roles.CINEMATOGRAPHER_DP]: {
    id: 'shared.crew.cinematographer-dp',
    defaultMessage: 'Cinematographer/DP',
  },
  [roles.ASSISTANT_CAMERA]: {
    id: 'shared.crew.assistant-camera',
    defaultMessage: 'Assistant Camera',
  },
  [roles.ADDITIONAL_PHOTOGRAPHY]: {
    id: 'shared.crew.additional-photography',
    defaultMessage: 'Additional Photography',
  },
  [roles['2ND_UNIT_DIR_OF_PHOTOGRAPHY']]: {
    id: 'shared.crew.2nd-unit-dir-of-photography',
    defaultMessage: '2nd Unit Dir of Photography',
  },
  [roles.CAMERA_OPERATOR]: {
    id: 'shared.crew.camera-operator',
    defaultMessage: 'Camera Operator',
  },
  [roles.GAFFER]: {
    id: 'shared.crew.gaffer',
    defaultMessage: 'Gaffer',
  },
  [roles.BEST_BOY]: {
    id: 'shared.crew.best-boy',
    defaultMessage: 'Best Boy',
  },
  [roles.KEY_GRIP]: {
    id: 'shared.crew.key-grip',
    defaultMessage: 'Key Grip',
  },
  [roles.ADDITIONAL_GRIP]: {
    id: 'shared.crew.additional-grip',
    defaultMessage: 'Additional Grip',
  },
  [roles.DOLLY_GRIP]: {
    id: 'shared.crew.dolly-grip',
    defaultMessage: 'Dolly Grip',
  },
  [roles.GRIP]: {
    id: 'shared.crew.grip',
    defaultMessage: 'Grip',
  },
  [roles.SOUND_MIXER]: {
    id: 'shared.crew.sound-mixer',
    defaultMessage: 'Sound Mixer',
  },
  [roles.BOOM_OPERATOR]: {
    id: 'shared.crew.boom-operator',
    defaultMessage: 'Boom Operator',
  },
  [roles.CABLE_PERSON]: {
    id: 'shared.crew.cable-person',
    defaultMessage: 'Cable Person',
  },
  [roles.VIDEO_OPERATOR]: {
    id: 'shared.crew.video-operator',
    defaultMessage: 'Video Operator',
  },
  [roles.ART_DIRECTOR]: {
    id: 'shared.crew.art-director',
    defaultMessage: 'Art Director',
  },
  [roles.ASSISTANT_ART_DIRECTOR]: {
    id: 'shared.crew.assistant-art-director',
    defaultMessage: 'Assistant Art Director',
  },
  [roles.COSTUME_DESIGNER]: {
    id: 'shared.crew.costume-designer',
    defaultMessage: 'Costume Designer',
  },
  [roles.COSTUMER]: {
    id: 'shared.crew.costumer',
    defaultMessage: 'Costumer',
  },
  [roles.HAIRSTYLIST]: {
    id: 'shared.crew.hairstylist',
    defaultMessage: 'Hairstylist',
  },
  [roles.LEAD_PERSON]: {
    id: 'shared.crew.lead-person',
    defaultMessage: 'Lead Person',
  },
  [roles.MAKEUP_ARTIST]: {
    id: 'shared.crew.makeup-artist',
    defaultMessage: 'Makeup Artist',
  },
  [roles.MAKEUP_EFFECTS]: {
    id: 'shared.crew.makeup-effects',
    defaultMessage: 'Makeup Effects',
  },
  [roles.PRODUCTION_DESIGNER]: {
    id: 'shared.crew.production-designer',
    defaultMessage: 'Production Designer',
  },
  [roles.PROPERTY_MASTER]: {
    id: 'shared.crew.property-master',
    defaultMessage: 'Property Master',
  },
  [roles.SET_DECORATOR]: {
    id: 'shared.crew.set-decorator',
    defaultMessage: 'Set Decorator',
  },
  [roles.SET_DESIGNER]: {
    id: 'shared.crew.set-designer',
    defaultMessage: 'Set Designer',
  },
  [roles.SWING_GANG]: {
    id: 'shared.crew.swing-gang',
    defaultMessage: 'Swing Gang',
  },
  [roles.ANIMAL_TRAINER]: {
    id: 'shared.crew.animal-trainer',
    defaultMessage: 'Animal Trainer',
  },
  [roles.CHOREOGRAPHER]: {
    id: 'shared.crew.choreographer',
    defaultMessage: 'Choreographer',
  },
  [roles.SPECIAL_EFFECTS]: {
    id: 'shared.crew.special-effects',
    defaultMessage: 'Special Effects',
  },
  [roles.STUNT_COORDINATOR]: {
    id: 'shared.crew.stunt-coordinator',
    defaultMessage: 'Stunt Coordinator',
  },
  [roles.TECHNICAL_ADVISOR]: {
    id: 'shared.crew.technical-advisor',
    defaultMessage: 'Technical Advisor',
  },
  [roles.EDITOR]: {
    id: 'shared.crew.editor',
    defaultMessage: 'Editor',
  },
  [roles.ASSISTANT_EDITOR]: {
    id: 'shared.crew.assistant-editor',
    defaultMessage: 'Assistant Editor',
  },
  [roles.SOUND_EDITOR]: {
    id: 'shared.crew.sound-editor',
    defaultMessage: 'Sound Editor',
  },
  [roles.DIGITAL_EFFECTS]: {
    id: 'shared.crew.digital-effects',
    defaultMessage: 'Digital Effects',
  },
  [roles.ORIGINAL_MUSIC_COMPOSER]: {
    id: 'shared.crew.original-music-composer',
    defaultMessage: 'Original Music/Composer',
  },
  [roles.ANIMATOR]: {
    id: 'shared.crew.animator',
    defaultMessage: 'Animator',
  },
  [roles.AGENT]: {
    id: 'shared.crew.agent',
    defaultMessage: 'Agent',
  },
  [roles.MANAGER]: {
    id: 'shared.crew.manager',
    defaultMessage: 'Manager',
  },
  [roles.PUBLICIST]: {
    id: 'shared.crew.publicist',
    defaultMessage: 'Publicist',
  },
  [roles.PRINT_SHIPPER]: {
    id: 'shared.crew.print-shipper',
    defaultMessage: 'Print Shipper',
  },
  [roles.PRINT_RETURN]: {
    id: 'shared.crew.print-return',
    defaultMessage: 'Print Return',
  },
  [roles.PREVIEW_RETURN]: {
    id: 'shared.crew.preview-return',
    defaultMessage: 'Preview Return',
  },
  [roles.ACADEMIC_ADVISOR]: {
    id: 'shared.crew.academic-advisor',
    defaultMessage: 'Academic Advisor',
  },
  [roles.SCHOOL_ADMINISTRATOR]: {
    id: 'shared.crew.school-administrator',
    defaultMessage: 'School Administrator',
  },
});

export const categories = defineMessages({
  [categoryKeys.POPULAR]: {
    id: 'shared.crew-category.popular',
    defaultMessage: 'Popular',
  },
  [categoryKeys.PRODUCTION]: {
    id: 'shared.crew-category.production',
    defaultMessage: 'Production',
  },
  [categoryKeys.WRITING]: {
    id: 'shared.crew-category.writing',
    defaultMessage: 'Writing',
  },
  [categoryKeys.CAMERA]: {
    id: 'shared.crew-category.camera',
    defaultMessage: 'Camera',
  },
  [categoryKeys.ELECTRICS]: {
    id: 'shared.crew-category.electrics',
    defaultMessage: 'Electrics',
  },
  [categoryKeys.GRIP]: {
    id: 'shared.crew-category.grip',
    defaultMessage: 'Grip',
  },
  [categoryKeys.SOUND_AND_VIDEO]: {
    id: 'shared.crew-category.sound-and-video',
    defaultMessage: 'Sound and video',
  },
  [categoryKeys.ART]: {
    id: 'shared.crew-category.art',
    defaultMessage: 'Art',
  },
  [categoryKeys.SPECIALIZED]: {
    id: 'shared.crew-category.specialized',
    defaultMessage: 'Specialized',
  },
  [categoryKeys.POST_PRODUCTION]: {
    id: 'shared.crew-category.post-production',
    defaultMessage: 'Post Production',
  },
  [categoryKeys.ANIMATION]: {
    id: 'shared.crew-category.animation',
    defaultMessage: 'Animation',
  },
  [categoryKeys.REPRESENTATION]: {
    id: 'shared.crew-category.representation',
    defaultMessage: 'Representation',
  },
  [categoryKeys.PRINT_TRAFFIC]: {
    id: 'shared.crew-category.print-traffic',
    defaultMessage: 'Print Traffic',
  },
  [categoryKeys.ACADEMIC]: {
    id: 'shared.crew-category.academic',
    defaultMessage: 'Academic',
  },
});



// WEBPACK FOOTER //
// ./src/shared/translations/crew.js